import { apiClient } from './client';

export type Tier = 'wild' | 'scatter' | 'h1' | 'h2' | 'm1' | 'm2' | 'l1' | 'l2';

export interface LineWin {
  line: number;
  tier: Tier;
  count: number;
  win: number;
}
export interface SpinEval {
  grid: Tier[][]; // [reel][row]
  lineWins: LineWin[];
  scatterCount: number;
  scatterWin: number;
  freeSpinsAwarded: number;
  totalWin: number;
}
export interface SlotSpinResult {
  betId: number;
  theme: string;
  base: SpinEval;
  free: SpinEval[];
  freeSpinsTotal: number;
  totalWin: string;
  amount: string;
  lineBet: string;
  newBalance: string;
  nonce: number;
  nextNonce: number;
  serverSeedHash: string;
  clientSeed: string;
  createdAt: string;
}

export type SlotGame = 'slots' | 'olympus' | 'doghouse';
export interface WinItem {
  betId: number;
  game: SlotGame;
  amount: string;
  payout: string;
  createdAt: string;
}
export interface ReplayResult {
  betId: number;
  game: SlotGame;
  amount: string;
  totalWin: string;
  play: any;
}

export const slotsApi = {
  spin: (amount: string, theme: string) =>
    apiClient.post<SlotSpinResult>('/slots/spin', { amount, theme }).then((r) => r.data),
  history: (limit = 15) =>
    apiClient.get(`/slots/history?limit=${limit}`).then((r) => r.data),
  wins: (limit = 20) =>
    apiClient.get<WinItem[]>(`/slots/wins?limit=${limit}`).then((r) => r.data),
  replay: (betId: number) =>
    apiClient.get<ReplayResult>(`/slots/replay/${betId}`).then((r) => r.data),
};
